module.exports = __webpack_public_path__ + "static/media/twitter.af24538e.svg";